
import React from 'react';
import { Button } from '@/components/ui/button';

interface YearSelectorProps {
  availableYears: number[];
  selectedYear: number;
  onChange: (year: number) => void;
  yearHasData: (year: number) => boolean;
}

const YearSelector = ({ 
  availableYears, 
  selectedYear, 
  onChange, 
  yearHasData 
}: YearSelectorProps) => {
  // Generate year button classes
  const getYearButtonClasses = (year: number) => {
    const baseClasses = "px-3 py-1 rounded-md text-sm font-medium transition-colors";
    if (year === selectedYear) {
      return `${baseClasses} bg-redflags-red text-white`;
    }
    return `${baseClasses} bg-gray-100 text-gray-700 hover:bg-gray-200`;
  };

  return (
    <div className="flex items-center space-x-2">
      {availableYears.map(year => (
        <Button 
          key={year}
          variant="ghost"
          className={getYearButtonClasses(year)}
          onClick={() => onChange(year)}
          disabled={!yearHasData(year) && year !== selectedYear}
        >
          {year}
        </Button>
      ))}
    </div>
  );
};

export default YearSelector;
